import { Instituicao } from './instituicao.model';
import { Regiao } from './regiao.model';
import { ResponsavelVO } from './responsavel-vo.model';

export class InstituicaoConveniadaVO {

  id: number;
  regiao: Regiao;
  instituicao: Instituicao;
  empresa: string;
  responsavel: ResponsavelVO;

}
